import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import queryString from 'query-string'

export function useQueryParams() {
    const location = useLocation()
    return useMemo(() => queryString.parse(location.search), [location.search])
}

export function setQueryStringWithoutPageReload(queryParams) {
    // Clean undefined, null or empty string values
    const cleanedParams = Object.entries(queryParams)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {})

    // Convert to query string
    const newQueryString = queryString.stringify(cleanedParams)

    // Update browser URL without page reload
    const newUrl = `${window.location.pathname}${newQueryString ? `?${newQueryString}` : ''}`
    window.history.pushState({ path: newUrl }, '', newUrl)
}
